<!-- Trigger del dropdown -->
<button
  (click)="toggle()"
  class="flex w-full cursor-pointer items-center justify-start gap-4 rounded-lg px-4 py-1 font-normal text-gray-700 duration-200 ease-in-out hover:font-semibold hover:text-black dark:text-gray-400 dark:hover:text-white">
  <ng-icon
    [name]="isOpen() ? route().iconFilled : route().iconOutline"
    size="20px" />
  <span class="flex-1 text-left text-nowrap">{{ route().title }}</span>
  <ng-icon
    [name]="isOpen() ? 'matExpandLess' : 'matExpandMore'"
    size="18px"
    class="transition-transform duration-200" />
</button>

<!-- Subitems -->
@if (isOpen()) {
  <div
    class="dropdown-children ml-4 flex flex-col gap-1 border-l border-gray-200 pl-3 dark:border-gray-700">
    @for (child of route().children; track child.path) {
      <a
        [routerLink]="child.path"
        routerLinkActive="text-black font-semibold dark:text-white"
        [routerLinkActiveOptions]="{
          exact: child.path === '' || child.path === '/',
        }"
        #rla="routerLinkActive"
        (click)="onChildClick()"
        class="flex scale-100 items-center justify-start gap-4 rounded-lg px-4 py-1 font-normal text-gray-700 duration-200 ease-in-out hover:font-semibold hover:text-black dark:text-gray-400 dark:hover:text-white">
        <ng-icon
          [name]="rla.isActive ? child.iconFilled : child.iconOutline"
          size="18px" />
        <span class="text-nowrap">{{ child.title }}</span>
      </a>
    }
  </div>
}
